import { updateManagerPageStep } from "./managerPageWizardService";
import apiClient from "./ApiService";

/**
 * Guarda CommerceData y actualiza ManagerPage
 */
export async function saveCommerceStep({ idTransaction, data, coords }) {
  const dto = {
    idAdmin: idTransaction,
    tradeName: data.name,
    mccId: data.mccId,
    businessActivity: data.activity,
    remodeling: data.remodelacion === "si",
    latitude: coords.lat || data.latitude,
    longitude: coords.lng || data.longitude,
    permanentAddress: data.locationPoint === "si",
    provinceId: Number(data.province),
    cantonId: Number(data.canton),
    districtId: Number(data.distrito),
    neighborhoodCode: Number(data.barrio),
    address: data.address,
    wazeName: data.rotulado,
    color: data.color,
    mobilePhoneExt: data.phone,
    workPhoneExt: data.phoneCommerce,
    email: data.emailElectronic,
    otherEmail: data.emailNotifications,
    chargebackEmail: data.emailNotificationsContra,
    recipientPerson: data.nameReceive,
    recipientPhone: data.phoneReceive,
    schedule: data.time,
    requireConfirmAppointment: data.confirmation === "si",
    commerceSide: data.commerceSide,
    constitutionDate: formatDate(data.constitutionDate)
  };

  let response ;
  try {
    response = await apiClient.post("/adelselfservice/selfservice/commerce-data", dto);
  } catch (error) {
    console.error("Error "+response)
  }
  //actualizar paso en ManagerPage
  await updateManagerPageStep(idTransaction, "commerceData");
  return true;
}

/**
 * Carga CommerceData si ya existe
 */
export async function getCommerceStep(idTransaction) {
 let response;
  try {
    response = await apiClient.get(
      `/adelselfservice/selfservice/commerce-data/admin/${idTransaction}`
    );
 } catch (error) {
  console.error(error)
 }
  return response;
}
const formatDate = (dateString) => {
  if (!dateString) return "";
  
  const date = new Date(dateString);
  
  const yyyy = date.getFullYear();
  const MM = String(date.getMonth() + 1).padStart(2, '0');
  const DD = String(date.getDate()).padStart(2, '0');
  const hh = String(date.getHours()).padStart(2, '0');
  const mm = String(date.getMinutes()).padStart(2, '0');

  return `${yyyy}-${MM}-${DD} ${hh}:${mm}`;
};